<div>
    <div class="attachment-container">
        <div>
            <div class="attachments">
                <div *ngIf="!loading && attachments.length === 0" class="no-attachments">
                    {{ 'bikeshop.modal.update_job_card.attachments.no_attachments' | translate }}
                </div>
                <div *ngFor="let item of attachments" class="attachment">
                    <div style="width: 100%;display: flex;">
            <span class="fa"
                  [ngClass]="{'fa-paperclip': item.mediaType.indexOf('image')===-1, 'fa-file-image-o': item.mediaType.indexOf('image')>-1 }"></span>
                        <span><a href="javascript:void(0)" (click)="openAttachment(item)">{{item.fileName}}</a></span>
                        <span *ngIf="item.serviceLogID===0" class="fa hubtiger-delete"
                              (click)="deleteAttachment(item)"></span>
                    </div>
                </div>
                <div *ngIf="loading">
                    <p-progressSpinner [style]="{width: '30px', height: '30px'}"
                                       animationDuration=".5s"></p-progressSpinner>
                </div>
            </div>
            <div class="qr-container" *ngIf="url && url.length>0">
                <qrcode [qrdata]="url" [width]="175" colorDark="#1e1e1e" [elementType]="'svg'" [errorCorrectionLevel]="'L'">
                </qrcode>
            </div>
        </div>
    </div>
    <div class="margin-top-8"><small>***
        {{ 'bikeshop.modal.update_job_card.attachments.qr_message' | translate }}</small>
    </div>
    <div class="row margin-top-16">
        <div class="col-md-8"></div>
        <div class="col-md-4">
            <button pButton type="button" class="p-button-raised full-width" (click)="fileUpload.click()"
                    label="{{'bikeshop.modal.update_job_card.attachments.add_attachment' | translate}}"></button>
            <input #fileUpload type="file" multiple accept="image/*;capture=camera" style="display: none"
                   (change)="addAttachment($event)">
        </div>
    </div>
</div>
